/* Copyright Flexday Solutions LLC, Inc - All Rights Reserved

 * Unauthorized copying of this file, via any medium is strictly prohibited

 * Proprietary and confidential

 * See file LICENSE.txt for full license details.

 */

import { Avatar, styled, Typography } from '@mui/material';

export const AvatarLetterWrap = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 'bold',
  color: theme.palette.primary.contrastText,

  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.pxToRem(12),
  },
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,

  [theme.breakpoints.down('sm')]: {
    height: '35px',
    width: '35px',
  },
}));

export const WhiteBorderedAvatar = styled(StyledAvatar)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  border: '1px solid #ededed',
}));
